<script setup lang="ts">
import type { AppTextareaEvent } from '@shared/ui/fields'
import type { AnnotatedTextareaProps } from '../../../model/assessments/annotated-textarea.hook'

import { AppText } from '@shared/ui/typography'
import { AppTextarea } from '@shared/ui/fields'
import { BtnSecondary } from '@shared/ui/buttons'

import { useAnnotatedTextarea } from '../../../model/assessments/annotated-textarea.hook'

defineOptions({
  name: 'AnnotatedTextarea',
})

const props = withDefaults(defineProps<AnnotatedTextareaProps>(), {
  value: '',
  label: '',
  placeholder: '',
  hint: '',
  disabled: false,
  required: false,
  markers: () => [],
  countAs: undefined,
})

const emit = defineEmits<{
  'update:value': [string]
}>()

const {
  refRoot,
  refValue,
  refMarkers,
  refCounterText,
  insertMarker,
  handleInput,
  getMarkerLabel,
} = useAnnotatedTextarea({
  props,
  onUpdateValue: (value: string) => emit('update:value', value),
})
</script>

<template>
  <div
    ref="refRoot"
    class="annotated-textarea"
  >
    <!-- Textarea and insert row sit side by side, 4/5 to 1/5: the buttons act on the caret inside
         the textarea, so they belong beside the field they edit, not stacked above it. -->
    <div class="annotated-textarea__field">
      <div class="annotated-textarea__input">
        <AppTextarea
          :value="refValue"
          :label="label"
          :placeholder="placeholder"
          :hint="hint"
          :disabled="disabled"
          :required="required"
          @input="(event: AppTextareaEvent) => handleInput(event.value)"
        />
      </div>
      <div
        v-if="refMarkers.length"
        class="annotated-textarea__insert"
      >
        <BtnSecondary
          v-for="marker in refMarkers"
          :key="marker"
          :text="getMarkerLabel(marker)"
          :disabled="disabled"
          @click="insertMarker(marker)"
        />
      </div>
    </div>
    <div
      v-if="refCounterText"
      class="annotated-textarea__meta"
    >
      <AppText
        name="body2"
        color="slate-500"
      >
        {{ refCounterText }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./AnnotatedTextarea.scss" />
